import axiosWithAuth from "../utils/axiosWithAuth";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

export const fetchFlows = async (mantisBusinessId, token) => {
  try {
    const url = `${API_URL}/businessFlows/getBusinessFlows`;
    console.log("Request URL:", url);

    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('flowsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      url,
      {
        mantisBusinessId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('flowsLoading', { detail: false });
    window.dispatchEvent(endEvent);

    console.log("Response:", response);
    return response.data.flows;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('flowsLoading', { detail: false });
    window.dispatchEvent(endEvent);

    console.error(
      "Error al obtener los flujos:",
      error.response?.data || error
    );
    throw error;
  }
};

export const createFlow = async (flowData) => {
  try {
    const url = `${API_URL}/businessFlows/createBusinessFlow`;
    console.log("Request URL:", url);

    const response = await axiosWithAuth.post(url, {
      name: flowData.name,
      description: flowData.description,
      mantisBusinessId: flowData.mantisBusinessId,
      mantisBusinessUserId: flowData.mantisBusinessUserId,
      fieldsToExtract: flowData.fieldsToExtract,
      flowDocuments: flowData.flowDocuments,
      conditionalFields: flowData.conditionalFields,
      documentCommonName: flowData.documentCommonName,
      documentCommonFormat: flowData.documentCommonFormat,
      calculatedFields: flowData.calculatedFields,
      documentFlowName: flowData.documentFlowName,
      sources: flowData.sources,
      contactPhone: flowData.contactPhone,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error al crear el flujo de negocio:",
      error.response?.data || error
    );
    throw error;
  }
};

export const deleteFlow = async (flowId, mantisBusinessId) => {
  try {
    const url = `${API_URL}/businessFlows/deleteBusinessFlow`;
    console.log("Request URL:", url);

    const response = await axiosWithAuth.post(url, {
      flowId: flowId,
      mantisBusinessId: mantisBusinessId,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error al eliminar el flujo de negocio:",
      error.response?.data || error
    );
    throw error;
  }
};

export const updateFlow = async (flowData, mantisBusinessId) => {
  try {
    const url = `${API_URL}/businessFlows/updateBusinessFlow`;
    console.log("Request URL:", url);

    const response = await axiosWithAuth.post(url, {
      flowId: flowData.id,
      name: flowData.name,
      description: flowData.description,
      mantisBusinessId,
    });
    return response.data;
  } catch (error) {
    console.error("Error al editar el flujo:", error.response?.data || error);
    throw error;
  }
};

export const saveFlowDocument = async (flowData, mantisBusinessId) => {
  try {
    const url = `${API_URL}/businessFlows/saveFlowDocument`;
    console.log("Request URL:", url);

    const response = await axiosWithAuth.post(url, {
      flowId: flowData.flowId,
      document: {
        name: flowData.document.name,
        description: flowData.document.description,
        mantisBusinessId,
        exampleDocument: {
          base64: flowData.document.exampleDocument.base64,
          name: flowData.document.exampleDocument.name,
          remoteFile: flowData.document.exampleDocument.remoteFile,
          type: flowData.document.exampleDocument.type,
        },
      },
      mantisBusinessId,
      isNew: flowData.isNew,
      fieldsToExtract: flowData.fieldsToExtract.map((field) => ({
        name: field.name,
        flowId: flowData.flowId,
        mantisBusinessId,
        nameInDocument: field.nameInDocument,
        format: field.format,
        position: field.position,
        additionalDetails: field.additionalDetails,
      })),
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error al guardar el documento del flujo:",
      error.response?.data || error
    );
    throw error;
  }
};

export const saveFlowConditionalFields = async (flowData, mantisBusinessId) => {
  try {
    const url = `${API_URL}/businessFlows/saveFlowConditionalFields`;
    console.log("Request URL:", url);

    const response = await axiosWithAuth.post(url, {
      flowId: flowData.flowId,
      conditionalFields: flowData.conditionalFields.map((field) => ({
        name: field.name,
        flowFieldToCompareId: field.flowFieldToCompareId,
        comparedWith: {
          type: field.comparedWith.type,
          value: field.comparedWith.value,
          fieldId: field.comparedWith.fieldId,
        },
        operator: field.operator,
        valueIfTrue: field.valueIfTrue,
        valueIfFalse: field.valueIfFalse,
      })),
      mantisBusinessId,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error al guardar los campos condicionales:",
      error.response?.data || error
    );
    throw error;
  }
};

export const deleteFlowConditionalField = async (fieldId, mantisBusinessId) => {
  try {
    const url = `${API_URL}/businessFlows/deleteFlowConditionalField`;
    console.log("Request URL:", url);

    const response = await axiosWithAuth.post(url, {
      fieldId: fieldId,
      mantisBusinessId,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error al eliminar el campo condicional:",
      error.response?.data || error
    );
    throw error;
  }
};

export const runManualFlow = async (flowId, mantisBusinessId, files) => {
  try {
    const url = `${API_URL}/businessFlows/runManualFlow`;
    const response = await axiosWithAuth.post(url, {
      flowId: flowId,
      mantisBusinessId: mantisBusinessId,
      files: files,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error al ejecutar el flujo manual:",
      error.response?.data || error
    );
    throw error;
  }
};

export const sendEmailReport = async (emailData, flowId, recordIds) => {
  try {
    // Primero enviar el correo
    const url = `${API_URL}/email/sendEmail`;
    console.log("Email Data:", emailData);

    const emailResponse = await axiosWithAuth.post(url, {
      toEmails: emailData.toEmails,
      subject: emailData.subject,
      message: emailData.message,
      attachments: [
        {
          mimeType:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          base64: emailData.attachments[0].base64,
          filename: emailData.attachments[0].filename,
        },
      ],
    });

    // Si el correo se envió exitosamente, actualizar el estado
    if (emailResponse.data && flowId === "679a422e2e68871d4571ef58") {
      await updateSentStatus(flowId, recordIds, "ENVIADO");
    }

    return emailResponse.data;
  } catch (error) {
    console.error(
      "Error en el proceso de envío:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateSentStatus = async (flowId, recordIds, estadoEnvio) => {
  try {
    const url = `${API_URL}/email/updateSentStatus`;
    console.log("Updating sent status:", { flowId, recordIds, estadoEnvio });

    const response = await axiosWithAuth.post(url, {
      flowId,
      recordIds,
      estadoEnvio
    });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error al actualizar estado de envío:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const listenToDocumentProcessing = (flowId, callbacks) => {
  try {
    const eventSource = new EventSource(
      `${API_URL}/businessFlows/notifyDocumentProcessing?flowId=${flowId}`,
      { withCredentials: true }
    );

    // Manejar mensajes recibidos
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === 'DOCUMENT_PROCESSING') {
        callbacks.onProcessing?.(data);
      }
    };

    // Manejar errores
    eventSource.onerror = (error) => {
      console.error('EventSource failed:', error);
      callbacks.onError?.(error);
      eventSource.close();
    };

    // Manejar conexión abierta
    eventSource.onopen = () => {
      callbacks.onOpen?.();
    };

    // Retornar función para cerrar la conexión
    return {
      close: () => {
        eventSource.close();
        callbacks.onClose?.();
      }
    };
  } catch (error) {
    console.error("Error al configurar SSE:", error);
    callbacks.onError?.(error);
    return {
      close: () => {}
    };
  }
};

export const scheduleEmailReport = async (scheduleData) => {
  try {
    const url = `${API_URL}/email/scheduleEmail`;
    console.log("Scheduling email with data:", scheduleData);

    const response = await axiosWithAuth.post(url, {
      flowId: scheduleData.flowId,
      toEmails: scheduleData.toEmails.split(',').map(email => email.trim()),
      subject: scheduleData.subject,
      message: scheduleData.message,
      scheduledTime: scheduleData.scheduledTime,
      frequency: scheduleData.frequency,
      filters: {
        estado: scheduleData.filters.estado,
        medioCarga: scheduleData.filters.medioCarga,
        oficio: scheduleData.filters.oficio
      }
    });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    console.log("Email scheduled successfully:", response.data);
    return response.data;

  } catch (error) {
    console.error(
      "Error al programar el correo:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateFlowResultField = async (flowResultId, fieldId, newValue) => {
  try {
    const url = `${API_URL}/businessFlows/updateFlowResultField`;
    console.log("Updating field:", { flowResultId, fieldId, newValue });

    const response = await axiosWithAuth.post(url, {
      flowResultId,
      fieldId,
      newValue
    });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    console.log("Field updated successfully:", response.data);
    return response.data;

  } catch (error) {
    console.error(
      "Error al actualizar el campo:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getFlowResultsFilterOptions = async (flowId, mantisBusinessId) => {
  try {
    const url = `${API_URL}/businessFlows/flowResultsFilterOptions?flowId=${flowId}&mantisBusinessId=${mantisBusinessId}`;

    const response = await axiosWithAuth.get(url);

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPreSignedUrl = async (fileName, mantisBusinessId) => {
  try {
    const url = `${API_URL}/businessFlows/generatePreSignedUrl?fileName=${fileName}&mantisBusinessId=${mantisBusinessId}`;

    const response = await axiosWithAuth.get(url);

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};
